import PropTypes from 'prop-types';

import { DynamicStat, Stat } from '../../components';

const componentMap = {
  dynamicStat: DynamicStat,
  stat: Stat,
};

const UniversalStat = ({ contentTypeId, ...props }) => {
  const Component = componentMap[contentTypeId];
  return Component ? <Component {...props} /> : <div />;
};

UniversalStat.propTypes = {
  contentTypeId: PropTypes.string.isRequired,
};

export default UniversalStat;
